import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// --- CONTEXTO ---
import { AuthProvider } from './context/AuthContext'; 

// --- COMPONENTES DE LAYOUT Y RUTAS ---
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthRoutes from './components/auth/AuthRoutes';
import UserMenu from './components/auth/UserMenu';

// --- PÁGINAS ---
import HomePageEn from './pages/home/HomePageEn';
import HomePageEs from './pages/home/HomePageEs';
import NostalgiaPage from './pages/es/NostalgiaPage';
import AfirmacionesPage from './pages/es/AfirmacionesPage';
import NivelesHawkinsPage from './pages/es/NivelesHawkinsPage';
import ManifiestaPage from './pages/es/ManifiestaPage';
import ManifiestaCallPage from './pages/es/ManifiestaCallPage';
import CursoPage from './pages/es/CursoPage';
import LoginPage from './pages/auth/LoginPage';
import SignUpPage from './pages/auth/SignUpPage';
import VerifyEmailPage from './pages/es/VerifyEmailPage';
import ActivityPage from './pages/es/ActivityPage';
import PaymentConfirmationPage from './pages/es/PaymentConfirmationPage';
import MeditationSevenPhases from './components/es/activities/meditation/MeditationSevenPhases';
import NewsletterPage from './components/es/NewsletterPage';
import NewsletterDetail from './components/es/NewsletterDetail';
import AboutPage from './pages/es/AboutPage';
import FreeResourcesPage from './pages/es/FreeResourcesPage';
import MainCoursePage from './pages/es/MainCoursePage';
import MasterclassSubscriptionPage from './pages/es/MasterclassSubscriptionPage';
import IceImmersionRetreatPage from './pages/es/IceImmersionRetreatPage';
import Bashar15MinutesAndCounting from './components/es/activities/Bashar15MinutesAndCounting';
import Bashar15MinutesAndCounting2 from './components/es/activities/Bashar15MinutesAndCounting2';
import OneToOneCoachingPage from './pages/es/OneToOneCoachingPage';
import BasharNewsletterPage from './pages/es/BasharNewsletterPage';
import Bashar15MinutesAndCounting3 from './components/es/activities/Bashar15MinutesAndCounting3';
import TheFormulaHandout from './components/es/bashar/TheFormulaHandout';
import ManifestationJournalPage from './pages/es/home/ManifestationJournalPage';
import BasharTransmissionsInterest from './pages/bashar/BasharInterestPage';
import BasharBookSubscriptionPage from './pages/bashar/BasharBook';
import SevenWhys from './components/tools/SevenWhys';
import FifteenMinutesNewBelief from './components/tools/FifteenMinutesNewBelief';
import WimHofBreathing from './components/tools/WimHofBreathing';
import SevenManifestationStepBook from './pages/books/7-step-manifestation/SevenStepManifestationBook';
import SevenManifestationStepBookEn from './pages/books/7-step-manifestation/SevenStepManifestationBookEn';
import TrafficSourceWrapper from './components/TrafficSourceWrapper';
import BasharSelector from './pages/bashar/BasharSelector';
import UserTransmissions from './pages/user/UserTransmissions';
import UserGift from './pages/user/UserGift';
import GoingGammaLeadMagnet from './pages/magnets/GoingGammaLeadMagnet';
import GoingGammaLeadMagnetEs from './pages/magnets/GoingGammaLeadMagnetEs';
import GammaActivationKit from './pages/magnets/gamma-tiers/GammaActivationKit';
import HolotropicMeditationLeadMagnet from './pages/magnets/HolotropicMeditationLeadMagnet';
import Checkout from './pages/checkout/Checkout';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import ProductManagement from './pages/product/ProductManagement';
import AdminRoute from './pages/auth/AdminRoute';
import UserDashboard from './pages/user/UserDashboard';
import SacredCircuitryLeadMagnet from './pages/magnets/SacredCircuitryLeadMagnet';
import HealingMeditations from './pages/magnets/HealingMeditationsLeadMagnet';
import NewsSender from './pages/admin/NewsSender';
import DailyOraclePage from './pages/user/DailyOraclePage';
import Unsubscribe from './pages/user/Unsubscribe';
import BasharTools from './pages/bashar/BasharTools';
import OracleDeckGridPage from './pages/oracle/OracleDeckGridPage';
import DailyPortalOraclePage from './pages/oracle/DailyPortalOraclePage';
import ThreeCardOracleSpreadPage from './pages/oracle/ThreeCardOracleSpreadPage';
import ConsciussWarriorPageEs from './pages/oracle/ConsciussWarriorPageEs';
import FiveCardStarSpreadPage from './pages/oracle/FiveCardStarSpreadPage';
import OracleMenuPageEs from './pages/home/OracleMenuPageEs';
import ManualThreeCardOracleSpreadPage from './pages/oracle/ManualThreeCardOracleSpreadPage';
import OracleCardDetailPage from './pages/oracle/OracleCardDetailPage';
import OracleCardCollectionPage from './pages/oracle/OracleCardCollectionPage';
import OracleMenuPageEn from './pages/home/OracleMenuPageEn';
import BasharMenuPageEn from './pages/home/BasharMenuPageEn';
import PremiumGammaKit from './pages/full-products/PremiumGammaKit';
import OracleCreditWidget from './pages/full-products/OracleCreditWidget';
import CoachingDashboard from './components/coaching/CoachingDashboard';
import TripleEnergySpreadPage from './pages/oracle/TripleEnergySpreadPage';
import HomePage from './pages/home/HomePage';
import RootRedirect from './pages/RootRedirect'
import HomePageMobile from './pages/home/HomePageMobile';
import PrivacyPolicy from './pages/google/PrivacyPolicy';
import DeleteAccount from './pages/google/DeleteAccount';
import useAndroidBackButton from './hooks/useAndroidBackButton';

// --- COMPONENTE PARA PÁGINA 404 ---
const NotFound = () => (
    <div style={{ 
        padding: '2rem', 
        textAlign: 'center', 
        color: 'white', 
        background: '#111827',
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
        fontFamily: 'sans-serif'
    }}>
        <h1 style={{ fontSize: '2.25rem', fontWeight: 'bold' }}>404 - Página No Encontrada</h1>
        <p style={{ marginTop: '0.5rem', color: '#d1d5db' }}>La ruta que buscas no existe o ha sido movida.</p>
        <a href="/menu" style={{ color: '#fcd34d', marginTop: '1.5rem', textDecoration: 'underline' }}>
            Volver al Menú Principal
        </a>
    </div>
);

function AndroidBackButton() {
  useAndroidBackButton();

  return (
    <></>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <AndroidBackButton/>
        <TrafficSourceWrapper> 
          <UserMenu />
          <Routes>

            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<DeleteAccount />} />

            {/* Rutas en Español */}
            <Route path="/oraculo" element={<OracleDeckGridPage lang = 'es' />} />
            <Route path="/oraculo/:id" element={<OracleCardDetailPage lang="es" />} />

            <Route path="/oraculo/categoria" element={<OracleCardCollectionPage lang="es" />} />
            <Route path="/oraculo/lectura/hoy" element={<DailyPortalOraclePage lang='es' />} />
            <Route path="/oraculo/lectura/estado" element={<ThreeCardOracleSpreadPage lang='es' />} />
            <Route path="/oraculo/lectura/triple" element={<TripleEnergySpreadPage lang='es' />} />
            <Route path="/oraculo/lectura/estrella" element={<FiveCardStarSpreadPage lang='es' />} />
            <Route path="/lectura-estrella" element={<FiveCardStarSpreadPage lang='es' />} />
            <Route path="/oraculo/menu" element={<OracleMenuPageEs />} />

            <Route path="/oraculo/lectura/manual" element={<ManualThreeCardOracleSpreadPage lang='es' />} />

            {/* Rutas de QR */}
            <Route path="/oraculo-portal" element={<Navigate replace to="/oraculo" />} />
            <Route path="/portal-oracle" element={<Navigate replace to="/oracle" />} />

            {/* Rutas en Inglés */}
            <Route path="/oracle" element={<OracleDeckGridPage lang = 'en' />} />
            <Route path="/oracle/:id" element={<OracleCardDetailPage lang="en" />} />

            <Route path="/oracle/category" element={<OracleCardCollectionPage lang="en" />} />
            <Route path="/oracle/reading/today" element={<DailyPortalOraclePage lang='en' />} />
            <Route path="/oracle/reading/state" element={<ThreeCardOracleSpreadPage lang='en' />} />
            <Route path="/oracle/reading/triple" element={<TripleEnergySpreadPage lang='en' />} />
            <Route path="/oracle/reading/star" element={<FiveCardStarSpreadPage lang='en' />} />
            <Route path="/oracle/menu" element={<OracleMenuPageEn />} />
            
            <Route path="/bashar/menu" element={<BasharMenuPageEn />} />

            {/* --- Conscius Warrior --- */}
            <Route path="/guerrero-consciente" element={<ConsciussWarriorPageEs />} />

            {/* --- Rutas Públicas (Visibles para todos) --- */}
            <Route path="/es/fb" element={<Navigate replace to="/es/menu" />} />
            <Route path="/es/yt" element={<Navigate replace to="/es/menu" />} />
            <Route path="/es/tk" element={<Navigate replace to="/es/menu" />} />
            <Route path="/es/ig" element={<Navigate replace to="/es/menu" />} />
            <Route path="/es" element={<Navigate replace to="/es/menu" />} />
            <Route path="/en/fb" element={<Navigate replace to="/en/menu" />} />
            <Route path="/en/yt" element={<Navigate replace to="/en/menu" />} />
            <Route path="/en/tk" element={<Navigate replace to="/en/menu" />} />
            <Route path="/en/ig" element={<Navigate replace to="/en/menu" />} />
            <Route path="/en" element={<Navigate replace to="/en/menu" />} />
            
            <Route path="/" element={<RootRedirect />} />
            <Route path="/:lang/menu" element={<HomePage />} />
            <Route path="/:lang/mobile/menu" element={<HomePageMobile />} />

            {/* --- Rutas de Autenticación (Solo para usuarios NO logueados) --- */}
            <Route element={<AuthRoutes />}>
              <Route path="/register" element={<Navigate replace to="/signup" />} />
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/:lang/signup" element={<SignUpPage />} />
              <Route path="/:lang/login" element={<LoginPage />} />
              <Route path="/:lang/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/:lang/reset-password" element={<ResetPasswordPage />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route path="/admin/products" element=
                {
                  <AdminRoute>
                    <ProductManagement />
                  </AdminRoute>
                } 
              /> 

              <Route path="/admin/news" element=
                {
                  <AdminRoute>
                    <NewsSender />
                  </AdminRoute>
                } 
              /> 

              {/* Rutas para el área de usuario (con el prefijo de idioma) */}
              {/* El comodín (*) asegura que cualquier URL que empiece con /:lang/user/ sea protegida */}
              <Route path="/user/*" element={<Navigate replace to="/user/dashboard" />} />
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/user/gamma-activation-kit" element={<GammaActivationKit />} />
              <Route path="/user/full-gamma-package" element={<PremiumGammaKit />} />
              <Route path="/user/oracle-reading-credits" element={<OracleCreditWidget />} />

              <Route path="/user/coaching-dashboard" element={<CoachingDashboard />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route path="/user/transmissions" element={<UserTransmissions />} />
              <Route path="/user/bashar-transmissions-gift" element={<UserGift />} />
              <Route path="/user/bashar-transmissions-gift-1" element={<UserGift />} />
              <Route path="/bashar/selector" element={<BasharSelector />} />

              <Route path='/user/healing-meditations' element={<HealingMeditations />} />

              <Route path="/shop" element={<Navigate replace to="/bashar/selector" />} />
            </Route>

            <Route element={<ProtectedRoute />}>

              <Route path="/user/wimhof-breathing-tool" element={<Navigate replace to="/en/wimhof" />} />

              <Route path="/sacred-circuitry-oracle" element={<DailyOraclePage />} />

              <Route path="/bashar/tools/15-min-count/1" element={<Bashar15MinutesAndCounting />} /> 
              <Route path="/bashar/tools/15-min-count/2" element={<Bashar15MinutesAndCounting2 />} /> 
              <Route path="/bashar/tools/15-min-count/3" element={<Bashar15MinutesAndCounting3 />} /> 

              <Route path="/bashar/tools" element={<BasharTools />} />

              <Route path="/bashar/going-gamma-breathing" element={<GoingGammaLeadMagnet />} />
            </Route>
            
            <Route element={<ProtectedRoute />}>
              <Route path="/user/7-phase-meditation" element={<MeditationSevenPhases />} />
              <Route path="/7-phase-meditation" element={<MeditationSevenPhases />} />
            </Route>

            <Route path="/es/wimhof" element={<WimHofBreathing />} />
            <Route path="/en/wimhof" element={<WimHofBreathing />} />
            <Route path="/wimhof" element={<WimHofBreathing />} />

            {/* <Route path="/guest/dashboard" element={<UserDashboard />} /> */}
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            
            <Route path='/healing-meditations' element={<HealingMeditations />} />
            
            <Route path="/checkout" element={<Checkout />} />
            

            <Route path="/bashar" element={<BasharTransmissionsInterest />} />
            <Route path="/bashar/15-minutes-and-counting" element={<BasharTransmissionsInterest />} />
            <Route path="/bashar/holotropic" element={<HolotropicMeditationLeadMagnet />} />



            <Route path="/going-gamma" element={<GoingGammaLeadMagnet />} />
            <Route path="/gamma" element={<GoingGammaLeadMagnet />} />
            <Route path="/es/gamma" element={<GoingGammaLeadMagnetEs />} />
            <Route path="/gamma-activation-kit" element={<GammaActivationKit />} />


            <Route path="/sacred-circuitry" element={<SacredCircuitryLeadMagnet />} />



            <Route path="/book" element={<BasharBookSubscriptionPage />} />

            <Route path="/es/7-7-why" element={<Navigate replace to="/los-7-pasos-para-manifestar/7-porques" />} />
            <Route path="/los-7-pasos-para-manifestar/7-porques" element={<SevenWhys />} />
            <Route path="/7-porques" element={<SevenWhys />} />

            <Route path="/es/7-15-min" element={<Navigate replace to="/los-7-pasos-para-manifestar/15-minutos" />} />
            <Route path="/los-7-pasos-para-manifestar/15-minutos" element={<FifteenMinutesNewBelief />} />
            <Route path="/15-minutos" element={<FifteenMinutesNewBelief />} />

            <Route path="/es/7-7-pha" element={<Navigate replace to="/los-7-pasos-para-manifestar/7-fases" />} />
            <Route path="/los-7-pasos-para-manifestar/7-fases" element={<MeditationSevenPhases />} />
            <Route path="/7-fases" element={<MeditationSevenPhases />} />
            <Route path="/sietefases" element={<MeditationSevenPhases />} />

            <Route path="/libros/journal-de-manifestacion" element={<ManifestationJournalPage />} />
            <Route path="/libros/los-7-pasos-para-manifestar" element={<SevenManifestationStepBook />} />
            <Route path="/libros/los-7-pasos-de-la-manifestacion" element={<Navigate replace to="/books/the-7-step-manifestation" />} />
            <Route path="/books/the-7-step-manifestation" element={<SevenManifestationStepBookEn />} />

            <>  {/* Paginas en español */}


            <Route path="/reprograma" element={<MainCoursePage />} />
            <Route path="/hielo" element={<IceImmersionRetreatPage />} />
            <Route path="/masterclasses" element={<MasterclassSubscriptionPage />} />
            <Route path="/coaching" element={<OneToOneCoachingPage />} />
            
            {/* --- PASO 4: Añade la nueva ruta aquí --- */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/recursos-gratuitos" element={<FreeResourcesPage />} />
            {/* --- NUEVAS RUTAS PARA NEWSLETTER --- */}
            <Route path="/newsletter" element={<NewsletterPage />} />
            <Route path="/newsletter/:campaign/:slug" element={<NewsletterDetail />} />
            {/* <Route path="/reprograma" element={<ReprogramaPage />} /> */}
            <Route path="/nostalgia" element={<NostalgiaPage />} />
            <Route path="/afirmaciones" element={<AfirmacionesPage />} />
            <Route path="/manifiesta" element={<ManifiestaPage />} />
            <Route path="/manifiesta-call" element={<ManifiestaCallPage />} />
            <Route path="/niveles" element={<NivelesHawkinsPage />} />
            <Route path="/confirmacion-pago" element={<PaymentConfirmationPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            

            {/* --- RUTAS DEL CURSO (LÓGICA MIXTA PÚBLICA/PRIVADA) --- */}
            <Route path="/cursos/manifiesta" element={<CursoPage />} /> 

            {/* --- EXCEPCIÓN: Actividades gratuitas del curso son PÚBLICAS --- */}
            <Route path="/cursos/manifiesta/12-areas-balance" element={<ActivityPage />} />
            <Route path="/cursos/manifiesta/concientizando-areas-balance" element={<ActivityPage />} />
            <Route path="/cursos/manifiesta/viendo-hacia-atras-desde-el-futuro" element={<ActivityPage />} />
            <Route path="/cursos/manifiesta/7-niveles-deep-why" element={<ActivityPage />} />
            <Route path="/cursos/manifiesta/meditacion-7-fases" element={<ActivityPage />} />
            <Route path="/cursos/manifiesta/primera-sesion-de-coaching" element={<ActivityPage />} />

            {/* --- Rutas No Gratuitas pero que se pueden acceder con un link --- */}
            <Route path="/cursos/manifiesta/umbral-de-creencia" element={<ActivityPage />} />

            {/* --- Rutas Protegidas (Solo para usuarios AUTENTICADOS) --- */}
            <Route element={<ProtectedRoute />}>
              <Route path="/cursos/manifiesta/:activitySlug" element={<ActivityPage />} />
            </Route>

            <Route path="/herramientas/7-fases" element={<MeditationSevenPhases />} /> 

            <Route path="/metafisica/bashar" element={<BasharNewsletterPage />} /> 
            
            <Route path="/metafisica/bashar/archivos/la-formula" element={<TheFormulaHandout />} /> 

            {/* --- Ruta "Catch-All" para Páginas no encontradas (404) --- */}
            <Route path="*" element={<NotFound />} />
            </>
          </Routes>
        </TrafficSourceWrapper>
      </AuthProvider>
    </Router>
  );
}

export default App;